/**
 * @generated SignedSource<<b68d51c81a2a97da34d38a450fdb07b4>>
 * @relayHash 50ff84ea54e839aa79f93547c298f298
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5e36cded1604834f694755e78ce841417aa6bc39651a41122979971dec25917

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b5e36cded1604834f694755e78ce841417aa6bc39651a41122979971dec25917",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider
    }
  }
};

export default node;
